<template>
  <div class="header">
    <el-row type="flex" justify="space-between">
      <div>
        <img class="logo" :src="imgsrc" alt="" />
        <span style="vertical-align: top">({{ currentEnv.title }})</span>
      </div>
      <el-col class="rightIcons" :span="8" align="right">
        <el-popover placement="bottom" width="400" trigger="click">
          <div class="pop-top">
            <div class="left-buttons">
              <el-button
                :class="selected === 'padding' ? 'active-popbutton' : ''"
                selected
                round
                size="small"
                @click="toggleButton('padding')"
                >待办<span>(0)</span></el-button
              >
              <el-button
                :class="selected === 'notice' ? 'active-popbutton' : ''"
                round
                size="small"
                @click="toggleButton('notice')"
                >通知<span>(0)</span></el-button
              >
            </div>
            <div class="right-button">清除</div>
          </div>
          <div v-if="selected === 'padding'">
            <div v-if="!isEmpty">
              <div class="pop-item">
                <div class="item-title">用户反馈</div>
                <div v-if="todayCount" class="item-content" @click="goFeedBack">
                  本日收到用户反馈{{ todayCount }}条
                </div>
                <div v-if="untreated" class="item-content" @click="goFeedBack">
                  未处理反馈{{ untreated }}条
                </div>
              </div>
              <div class="item-footer">全部已读</div>
            </div>
            <div class="pop-empty" v-else>
              <img class="emptyImg" :src="emptyImg" alt="" srcset="" />
              <div>暂无待办</div>
            </div>
          </div>
          <div v-if="selected === 'notice'">
            <div class="pop-empty">
              <img class="emptyImg" :src="emptyImg" alt="" srcset="" />
              <div>暂无通知</div>
            </div>
          </div>
          <span class="icon-bell" slot="reference">
            <img class="bell-img" :src="bellImg" alt="" srcset="" />
          </span>
        </el-popover>
        <!-- <span></span> -->
        <!-- <el-button class="roleName" size="medium">{{ roleName }}</el-button> -->
        <el-dropdown trigger="click" class="user-name" @command="handleCommand">
          <el-avatar :size="32" :src="avatar || circleUrl"></el-avatar>
          <el-dropdown-menu slot="dropdown">
            <!-- <el-dropdown-item command="profile">个人资料</el-dropdown-item> -->
            <el-dropdown-item command="userInfo">
              <!-- <router-link :to="{
        path:'/changepwd'
      }"> -->
              <i class="el-icon-user"></i>
              个人信息
              <!-- </router-link> -->
            </el-dropdown-item>
            <el-dropdown-item command="logout" divided>
              <i class="el-icon-switch-button"></i>
              退出登录
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { todayDate, env } from "../../utils/util";
import { removeToken, getUserName } from "../../utils/auth";
import projectConfig from "@/constant/projectConfig";
import { requestuserFeedbackCount } from "@/api/userApi";
export default {
  name: "RightHeader",
  data() {
    return {
      imgsrc: require("@/assets/images/yhe@2x.png"),
      circleUrl: require("@/assets/images/useravatar@2x.png"),
      bellImg: require("@/assets/images/bell@2x.png"),
      emptyImg: require("@/assets/images/404 1@2x.png"),
      selected: "padding",
      isEmpty: true,
      roleName: this.$store.state.userInfo.roleName || "",
      userName: getUserName(),
      flag: true,
      path: [],
      todayCount: 0,
      untreated: 0,
    };
  },
  methods: {
    handleCommand(command) {
      switch (command) {
        case "logout":
          {
            removeToken();
            this.$router.replace({ path: "/login" });
            localStorage.removeItem("userInfo");
            location.reload();
          }
          break;
        case "userInfo": {
          const id = JSON.parse(localStorage.getItem("userInfo")).id || "";
          this.$router.push({
            path: "/personalInfo",
            query: {
              id,
              // roleList: JSON.stringify(userInfo.roleList || []),
            },
          });
        }
      }
    },
    pathfn(pathlist, target, arr) {
      var pathflag = false;
      let idx = 0;
      if (pathlist && target && arr) {
        // console.log(pathlist,999);
        var flag = pathlist.some((item, index) => {
          idx = index;
          if (item) {
            pathflag = this.pathfn(item.children, target, [
              ...arr,
              {
                path: item.path,
                name: item.name,
                query: item.isquery ? this.$route.query : {},
              },
            ]);
            return item.path == target || pathflag;
          }
          return false;
        });
        if (flag || pathflag) {
          var path = pathlist[idx].path
            ? pathlist[idx].path
            : pathlist[idx].children[0].path;
          return pathflag
            ? pathflag
            : [
                ...arr,
                {
                  path,
                  name: pathlist[idx].name,
                  query: this.$route.query,
                },
              ];
        }
        return false;
      }
    },
    toggleButton(type) {
      this.selected = type;
    },
    goFeedBack() {
      // this.todayCount = 0;
      // this.untreated = 0;
      // this.isEmpty = true;
      this.$router.push({
        path: "/feedback",
      });
    },
  },
  computed: {
    currentEnv() {
      return env();
    },
    pathlist() {
      return this.pathfn(this.projectConfig.LEFT_MENU, this.$route.path, []);
    },
    avatar() {
      return this.$store.state.userInfo.avatar;
    },
  },
  async created() {
    // this.avatar = JSON.parse(localStorage.getItem("userInfo")).avatar;
    // this.avatar = this.$store.state.userInfo.avatar;
    // const { data } = await requestuserFeedbackCount();
    // // console.log('data===',data);
    // if (data.code === 1000) {
    //   this.todayCount = data.data.result.todayCount;
    //   this.untreated = data.data.result.untreated;
    //   this.isEmpty = !this.todayCount && !this.untreated;
    // } else {
    //   this.$message.error(data.msg);
    // }
    // console.log(localStorage.getItem("userInfo"));
  },
};
</script>

<style lang="less" scoped>
.rightIcons {
  padding-top: 10px;
}
.roleName {
  border-radius: 20px !important;
}
.user-name {
  margin-left: 20px;
}

.header {
  background-color: white;
  width: 100%;
  height: 100%;
}
.logo {
  width: 60px;
  height: 32px;
  margin-top: 14px;
}
.icon-bell {
  position: relative;
  display: inline-block;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: #c9cdd4;
}
.bell-img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 16px;
  height: 16px;
}
.pop-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 48px;
  padding: 0 16px;
  border-bottom: 1px solid #e5e6eb;
}
.active-popbutton {
  color: #409eff;
  background-color: #ecf5ff;
}
.right-button {
  cursor: pointer;
  color: #165dff;
}
.pop-item {
  padding: 16px;
  border-bottom: 1px solid #e5e6eb;
}
.item-title {
  font-weight: 600;
  padding-bottom: 7px;
}
.item-content {
  padding-bottom: 10px;
}
.item-footer {
  height: 50px;
  line-height: 50px;
  cursor: pointer;
  text-align: center;
  color: #165dff;
}
.pop-empty {
  height: 350px;
  text-align: center;
  .emptyImg {
    width: 100px;
    height: 100px;
    padding-top: 100px;
  }
}
.el-dropdown-menu a {
  color: #606266;
  display: inline-block;
}
</style>
